module.exports = __webpack_public_path__ + "static/media/55_000035.4c2b6068.jpg";